module.exports = __webpack_public_path__ + "img/Location.c435fe88.png";